import { render, staticRenderFns } from "./EditRegistersView.vue?vue&type=template&id=8851783c&scoped=true&lang=html&"
import script from "./EditRegistersView.vue?vue&type=script&lang=ts&"
export * from "./EditRegistersView.vue?vue&type=script&lang=ts&"
import style0 from "./EditRegistersView.vue?vue&type=style&index=0&id=8851783c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8851783c",
  null
  
)

export default component.exports